export default "__VITE_ASSET__BSjy3Koj__"